import React from "react";

import svg from "../../assets/images/icons/drag_drop.svg";

export const DragDropIcon = ({ alt }: { alt?: string }) => (
    <img
        src={svg}
        alt={alt || "Drag and Drop"}
    />
);
